const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_BASE_API,
  ENDPOINTS: {
    ARTICLE_TYPE_LIST: 'api/article/type/list',
    ARTICLE_CONTENT_LIST: 'api/article/content/list',
    ARTICLE_DETAIL: 'api/article/content/info',
    ARTICLE_IMAGE_LIST: 'api/article/image/list'
  }
}

function getApiUrl(endpoint, params = '') {
  return API_CONFIG.BASE_URL + endpoint + params
}

export { API_CONFIG, getApiUrl }